import snakeCase from 'lodash/snakeCase';
import withProps from 'recompose/withProps';
import Interest from './Interest';
import splitPrismicKeyVals from 'src/common/utils/split-prismic-key-vals';
import { matchDefaultCustomisation } from 'src/client/js/view/utils/match-customisation';

const enhance = withProps(props => ({
  interestType: snakeCase(props.drawer.type),
  items: props.drawer.items.reduce((items, item) => {
    if (matchDefaultCustomisation(props.productCustomisation, item)) {
      const extraChoice = splitPrismicKeyVals(item.extraChoices);
      return items.concat({
        ...item,
        id: extraChoice ? extraChoice.value : item.id,
      });
    }
    return items;
  }, []),
}));

export default enhance(Interest);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Interest/index.js